// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Task } from '@medplum/fhirtypes';

export const TASK_ASSOCIATED_ACTION_URL = 'https://polarissleep.com/fhir/StructureDefinition/task-associated-action';

export type TaskAssociatedActionCode = 'parachute' | 'myair' | 'airview' | 'stripe' | 'stedi';

export interface TaskAssociatedActionMeta {
  code: TaskAssociatedActionCode;
  /** Label shown in the task creation dropdown */
  label: string;
  /** Label shown on the task card "Go to ..." button */
  buttonLabel: string;
}

export const TASK_ASSOCIATED_ACTIONS: readonly TaskAssociatedActionMeta[] = [
  { code: 'parachute', label: 'Go to Parachute (Order CPAP)', buttonLabel: 'Go to Parachute' },
  { code: 'myair', label: 'Go to MyAir (Compliance)', buttonLabel: 'Go to MyAir' },
  { code: 'airview', label: 'Go to AirView (RPM)', buttonLabel: 'Go to AirView' },
  { code: 'stripe', label: 'Go to Stripe (Payments)', buttonLabel: 'Go to Stripe' },
  { code: 'stedi', label: 'Go to Stedi (Eligibility / Claims)', buttonLabel: 'Go to Stedi' },
];

const ACTIONS_BY_CODE = new Map(TASK_ASSOCIATED_ACTIONS.map((meta) => [meta.code, meta]));

export function getTaskAssociatedActionCode(task: Task): TaskAssociatedActionCode | undefined {
  const ext = task.extension?.find((e) => e.url === TASK_ASSOCIATED_ACTION_URL);
  const value = ext?.valueCode;
  if (value && ACTIONS_BY_CODE.has(value as TaskAssociatedActionCode)) {
    return value as TaskAssociatedActionCode;
  }
  return undefined;
}

export function getTaskAssociatedActionMeta(task: Task): TaskAssociatedActionMeta | undefined {
  const code = getTaskAssociatedActionCode(task);
  return code ? ACTIONS_BY_CODE.get(code) : undefined;
}
